import React from 'react'
import Img from 'gatsby-image'

import BusinessSection from '@/business-section'

import './styles.css'

const SectionRatingBeauty = ({ data }) => {
  return (
    <BusinessSection
      title="Rating tools"
      subtitle="for judge rating"
      topText="Advanced"
      topGreen
    >
      <div className="flex flex-wrap items-center justify-center mb6">
        <div className="w-37 mw318">
          <Img sizes={data.ratingImg1.sizes} alt="" />
        </div>
        <div className="w-23 mw196">
          <Img sizes={data.ratingImg2.sizes} alt="" />
        </div>
        <div className="w-21 mw180">
          <Img sizes={data.ratingImg3.sizes} alt="" />
        </div>
        <div className="w-19 mw158">
          <Img sizes={data.ratingImg4.sizes} alt="" />
        </div>
      </div>
    </BusinessSection>
  )
}

export default SectionRatingBeauty



// WEBPACK FOOTER //
// ./src/components/section-rating/section-rating.js